const getMinNumberOfLeadingSpaces = (lines: string[]) => {
  return Math.min(
    ...lines.map((line) => {
      const index = line.search(/\S/);
      return index === -1 ? Infinity : index;
    }),
  );
};

const extractCodeFragment = (lines: string[], section: string) => {
  const beginTag = `-- #begin ${section}`;
  const endTag = `-- #end ${section}`;
  const extractedLines: string[] = [];
  let shouldAppend: boolean;
  lines.forEach((line) => {
    if (line.trim() === beginTag) {
      shouldAppend = true;
      return;
    }
    if (line.trim() === endTag) {
      shouldAppend = false;
    }
    if (shouldAppend) {
      extractedLines.push(line);
    }
  });
  return extractedLines;
};

const processLuaCode = (content: string, section?: string) => {
  const lines = content.split(/\r?\n/);
  let unformattedCode: string[];
  if (section !== undefined) {
    unformattedCode = extractCodeFragment(lines, section);
  } else {
    unformattedCode = lines.filter(
      (line) => !line.includes('-- #begin') && !line.includes('-- #end'), // ignore tags when no extraction needed
    );
  }
  const minNumberOfLeadingSpaces = getMinNumberOfLeadingSpaces(unformattedCode);
  return unformattedCode
    .map((line) => line.substring(minNumberOfLeadingSpaces)) // indent code properly
    .join('\n');
};

export default processLuaCode;
